import React, { useState } from 'react'
import { Facebook, Twitter, Linkedin, Instagram, Youtube } from 'lucide-react'
import { Link } from 'react-router-dom'

const Footer = () => {
  const [email, setEmail] = useState('')

  const helpfulLinks = [
    { label: 'Xpress Logistics', to: '/services' },
    { label: 'Xpress MyPackage', to: '/services/express-delivery' },
    { label: 'Industry Expertise', to: '/about-us' },
    { label: 'FAQs', to: '/contact-us' }
  ]

  const trackLinks = [
    { label: 'Track Your Shipments', to: '/track-shipment' },
    { label: 'Get A Quote', to: '/get-a-quote' },
    { label: 'Schedule A Pickup', to: '/contact-us' },
    { label: 'Locate Us', to: '/contact-us' }
  ]

  const aboutLinks = [
    { label: 'About Us', to: '/about-us' },
    { label: 'Our Services', to: '/services' },
    { label: 'Careers', to: '/contact-us' },
    { label: 'News & Updates', to: '/blogs' }
  ]

  const contactLinks = [
    { label: 'Customer Care', to: '/contact-us' },
    { label: 'Contact Us', to: '/contact-us' },
    { label: 'Feedback', to: '/contact-us' }
  ]

  const socialLinks = [
    {
      icon: Facebook,
      url: 'https://www.facebook.com/people/S-Infinite-Express/61578114767602/',
      label: 'Facebook'
    },
    {
      icon: Twitter,
      url: 'https://x.com/SInfinite01',
      label: 'Twitter'
    },
    {
      icon: Instagram,
      url: 'https://www.instagram.com/',
      label: 'Instagram'
    },
    {
      icon: Linkedin,
      url: 'https://in.linkedin.com/company/s-infinite-express',
      label: 'LinkedIn'
    },
    {
      icon: Youtube,
      url: 'https://www.youtube.com/',
      label: 'YouTube'
    }
  ]

  const FooterColumn = ({ title, links }) => (
    <div className='min-w-0'>
      <h4 className='text-[15px] font-semibold text-[#211f57] mb-3'>{title}</h4>

      <ul className='space-y-3'>
        {links.map((item, index) => (
          <li key={`${item.label}-${index}`}>
            <Link
              to={item.to}
              className='text-[13px] sm:text-[14px] text-[#333333] hover:text-[#d32c30] transition-colors duration-200'
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )

  const handleSubscribe = e => {
    e.preventDefault()

    if (!email.trim()) return

    window.location.href = `mailto:info@sinfiniteexpress.com?subject=${encodeURIComponent(
      'Newsletter Subscription'
    )}&body=${encodeURIComponent(
      `Please subscribe ${email} to the newsletter.`
    )}`
  }

  return (
    <footer className='w-full bg-[#fffff]'>
      {/* ================= MAIN WHITE FOOTER ================= */}

      <div className='max-w-[1400px] mx-auto px-4 lg:px-10 pt-[25px] pb-[20px] mb-16 sm:mb-8'>
        {/* Five Column Layout */}
        <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-4 sm:gap-x-8 gap-y-8 sm:gap-y-12'>
          {/* Helpful Links */}

          <FooterColumn title='Helpful Links' links={helpfulLinks} />

          {/* Track */}

          <FooterColumn title='Track' links={trackLinks} />

          {/* About */}

          <FooterColumn title='About' links={aboutLinks} />

          {/* Contact */}

          <FooterColumn title='Contact' links={contactLinks} />

          {/* Newsletter */}

          <div className='min-w-0 col-span-2 sm:col-span-1'>
            <div className='mb-1'>
              <h4 className='text-[16px] font-semibold text-[#211f57] tracking-tight'>
                Stay Connected With Us
              </h4>
            </div>

            {/* Newsletter Form */}
            <form
              onSubmit={handleSubscribe}
              className='flex w-full h-[46px] group'
            >
              <input
                type='email'
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder='Enter your email address'
                className='w-full min-w-0 bg-[#fafafa] border border-gray-200 px-4 text-[13px] text-[#211f57] outline-none focus:bg-white focus:border-[#211f57] transition-all duration-300'
              />

              <button
                type='submit'
                className='shrink-0 px-6 bg-[#d32c30] text-white text-[13px] font-bold tracking-wide hover:bg-[#211f57] transition-all duration-300 shadow-sm'
              >
                GO
              </button>
            </form>

            {/* Social Media */}
            <div className='mt-3'>
              <p className='text-[11px] font-semibold tracking-[1.5px] uppercase text-gray-400 mb-1'>
                Follow Us
              </p>

              <div className='flex flex-wrap items-center gap-3'>
                {socialLinks.map(({ icon: Icon, url, label }) => (
                  <a
                    key={label}
                    href={url}
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label={label}
                    className='w-9 h-9 shrink-0 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-[#211f57] hover:border-[#211f57] hover:text-white transition-all duration-300'
                  >
                    <Icon size={16} strokeWidth={1.8} />
                  </a>
                ))}
              </div>
            </div>

            {/* Company Branding */}
            <div className='mt-2 pt-2 border-t border-gray-100'>
              <Link to='/' className='inline-block group'>
                <h2 className='text-[18px] font-extrabold tracking-tight leading-none whitespace-nowrap'>
                  <span className='text-[#d32c30]'>S </span>
                  <span className='text-[#211f57]'>
                    INFINITE EXPRESS PVT. LTD.
                  </span>
                </h2>

                <p className='text-[9px] font-semibold tracking-[2px] text-[#211f57] mt-1'>
                  YOUR TRUSTED LOGISTICS PARTNER
                </p>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* ================= BLUE COPYRIGHT BAR ================= */}

      {/* <div className='w-full bg-[#211f57]'> */}
      <div className='fixed bottom-0 left-0 w-full z-[9999] bg-[#11194C] shadow-[0_-4px_15px_rgba(0,0,0,0.10)]'>
        <div className='max-w-[1400px] mx-auto px-6 lg:px-10 py-[13px]'>
          <div className='flex flex-col md:flex-row items-center justify-between gap-3'>
            {/* Copyright */}

            <p className='text-[13px] text-white text-center md:text-left'>
              © {new Date().getFullYear()} S Infinite Express Pvt. Ltd. All
              rights reserved.
            </p>

            {/* Policies */}

            <div className='flex items-center gap-6 text-[13px] text-white'>
              <Link
                to='/privacy-policy'
                className='hover:text-[#ffae29] transition-colors'
              >
                Privacy Policy
              </Link>

              <Link
                to='/terms-and-conditions'
                className='hover:text-[#ffae29] transition-colors'
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
